import * as EventUtils from '../../../../shared/app/utils/event-utils';
import previewVideoTemplate from './preview-video.tpl.html';
import './preview-video.less';

export const previewVideoComponentModule = angular
  .module('Q.components.preview-video', [])

  .directive(
    'previewVideo',
    function (
      $window,
      $document,
      $compile,
      $rootScope,
      $animate,
      $sce,
      $timeout,
    ) {
      let playerElem = null;
      let playerScope = null;

      function showVideo(id) {
        // YouTube Options:
        // autoplay=1 - Play Automatically
        // enablejsapi=1 - Enables JS Control
        // modestbranding=1 - Reduces YouTube nonsense
        // playsinline=1 - Enables inline playback in some iOS situations
        // rel=0 - No related videos
        // showinfo=0 - Less noise before the video starts
        // color=white - White controls (not red)
        // iv_load_policy=3 - Hides video annotations
        let url = $sce.trustAsResourceUrl(
          'https://www.youtube.com/embed/' +
            id +
            '?autoplay=1&enablejsapi=1&modestbranding=1&playsinline=1&rel=0&showinfo=0&color=white&iv_load_policy=3&vq=hd720',
        );
        if (!playerElem) {
          playerScope = $rootScope.$new();
          playerScope.hide = hideVideo;
          playerElem = $compile(previewVideoTemplate)(playerScope);
          $animate
            .enter(playerElem, $document.find('body'))
            .then(() => $timeout(() => (playerScope.url = url), 200));
        }
      }

      function hideVideo() {
        if (playerElem) {
          let oldScope = playerScope;
          $animate.leave(playerElem).then(() => oldScope.$destroy());
          playerElem = null;
          playerScope = null;
        }
      }

      return {
        restrict: 'A',
        link(scope, elem, attr) {
          elem.on('click', function ($event) {
            EventUtils.stopEvent($event);
            showVideo(attr.previewVideo);
          });
        },
      };
    },
  );
